if (typeof $ === 'undefined') { throw new Error('This application\'s JavaScript requires jQuery') }

// APP START
// -----------------------------------
angular.module('ui.sortable',[])
angular.module('angularSpectrumColorpicker',[])
angular.module('mgcrea.ngStrap.core',[])
const App = angular.module('angle', [
  'ngTouch',
  'ngStorage',
  'ngCookies',
  'ui.bootstrap',
  'ui.router',
  'oc.lazyLoad',
  'cfp.loadingBar',
  'ngSanitize',
  //'schemaForm',
  'elif',
  'restmod',
  'uiRouterStyles',
  'ngInflection',
  'ui.mask',
  // 'checklist-model',
  'ngDialog',
  'toaster',
  'luegg.directives', // scroll glue
  'duScroll',
  'infinite-scroll'
])

App.config(function(restmodProvider, SERVER_BASE_URL, $httpProvider, $cookiesProvider){
  // Every $cookies write gets SameSite=Lax (CSRF hardening). Needs angular-cookies >= 1.7.1.
  $cookiesProvider.defaults.samesite = 'lax'

  restmodProvider.rebase({
    $config: {
      urlPrefix: SERVER_BASE_URL,
      name:'data',
      plural:'data'}

    }, 'restmodMixin')
    restmodProvider.rebase('AMSApi'); // given the mixin is called MyStyleApi
    restmodProvider.rebase('DirtyModel');

    //Reset headers to avoid OPTIONS request (aka preflight)
    $httpProvider.defaults.headers.common = {}
    $httpProvider.defaults.headers.post = {}
    $httpProvider.defaults.headers.put = {}
    $httpProvider.defaults.headers.patch = {}

    $httpProvider.interceptors.push(function($q, $rootScope) {
      // on any http response - if the backend is unresponsive, then redirect to the maintenance page
      return {
        responseError: function(rejection) {
          if(
              // uncomment those ones when maintenance downtime is known
              // rejection.status <= 0 || // net::ERR_CONNECTION_REFUSED
              // rejection.status === 502 || // `Bad Request`
              (rejection.status === 503 && rejection.data && rejection.data.data && rejection.data.data.maintenance_mode)
            ) {
              // set maintenance mode (show maintenance page) if server returns 503 or doesn't response at all
              $rootScope.maintenance_mode = true
              if(rejection.config && rejection.config.params && rejection.config.params.from_intake_page) {
                // simple form of the maintenance page for the appt booking page
                $rootScope.maintenance_mode_common = true
                var maintenance_timerange = moment().format('dddd MMMM D') // current date
                maintenance_timerange += ' from 2 PM - 5 PM ET' // comment this out when you don't know a specific timerange
                $rootScope.maintenance_timerange = maintenance_timerange
              }
              return
          }
          return $q.reject(rejection);
        }
      }
    })
})

App.run( ($rootScope, $state, $stateParams, $http, $window, responseHelper, $templateCache, authService, $ocLazyLoad, APP_REQUIRES, ngDialog, Appointment, Perm, SERVER_BASE_URL, $location, $api, ENVIRONMENT) => {
    // Set reference to access them from any scope
    $rootScope.$state = $state
    $rootScope.$stateParams = $stateParams
    authService.setCookie({ server_base_url: SERVER_BASE_URL })

    try {
      $rootScope.$storage = $window.localStorage
      $rootScope.localStorageSupport = true
    } catch (e) {
      $rootScope.$storage = null
      $rootScope.localStorageSupport = false
    }

    lg("Opening NexHealth...")
    $templateCache.put('PREVIEWCAMPAIGN', "{{preview}}");

    $rootScope.set_main_location = locationId => {
      // Re-fetch location data in case it was changed via an API call. Particularly when assigning
      // campaigns to one location, templates by appointment types may become enabled for a
      // different location.
      Perm.loadLocation(locationId).then(newLocationData => {
        let index = $rootScope.locations.findIndex(location => location.id === locationId)
        $rootScope.locations[index] = newLocationData
        Perm.set_loc(newLocationData)
      }, () => {
        $rootScope.loaderror = true
      })
    }

    // Uncomment this to disable template cache
    $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) => {
      //if (typeof(toState) !== 'undefined'){
      //  $templateCache.remove(toState.templateUrl)
      //}
    })

    $rootScope.user = {
      id:               authService.getUserId(),
      name:             authService.getUserName(),
      email:            authService.getUserEmail(),
      title:            authService.getUserType(),
      meta_type:        authService.getUserType(),
      picture:          authService.getUserImageUrl(),
      min_appt_length:  authService.getMinApptLength(),
      patientable:      authService.isPatientable()
    }
    $rootScope.impersonated = authService.impersonated()
    $rootScope.impersonationSessionId = authService.impersonationSessionId()
    $rootScope.subdomain = authService.getUserSubdomain()
    $rootScope.location_ref = $location

    $rootScope.$on('$stateChangeSuccess',
    function(event, toState, toParams, fromState, fromParams){
      // display new view from top
      $window.scrollTo(0, 0)
      // Save the route title
      $rootScope.pageTitle()
    })

    // Scope Globals
    // -----------------------------------
    $rootScope.app = {
      name: 'NexHealth',
      description: 'The Patient Experience Platform',
      year: ((new Date()).getFullYear()),
      layout: {
        horizontal: false,
      }
    }

    $rootScope.pageTitle = () => {
      var title
      if ($state.current.data) {
        title = `${$state.current.data.title} | ${$rootScope.app.name}`
      } else {
        title = `${$rootScope.app.name} | ${$rootScope.app.description}`
      }

      $rootScope.currTitle = title
      document.title = title
    }

    $rootScope.pageTitle()

    $rootScope.is_blank = (obj,key) => {
      return (
        typeof obj[key] == 'undefined' ||
        obj[key] == null ||
        obj[key] == false ||
        obj[key] == ""
      )
    }

    $http.defaults.headers.put["Content-Type"] = "application/json;charset=UTF-8";
    $http.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";

    $rootScope.logOut = () => {
      const { redirectAfterLogoutUrl } = authService.willUnauthorizeUser()
      window.location.href = redirectAfterLogoutUrl;
    }

    $rootScope.api_base = SERVER_BASE_URL

    lg("Done opening NexHealth...")

    $rootScope.message_modal = (opts) => {
      return ngDialog.open({
        template: '/app/views/modal/alert.html',
        data: {text: opts.msg, title: opts.title },
        controller: 'confirmCtrl',
        className: 'ne__modal'
      })
    }

    $rootScope.rename_modal = (opts) => {
      return ngDialog.open({
        template: '/app/views/modal/rename.html',
        data: opts,
        controller: 'renameCtrl',
        className: 'ne__modal'
      })
    }

    $rootScope.confirm_modal = (opts) => {
      return ngDialog.open({
        template: '/app/views/modal/confirm.html',
        data: opts,
        controller: 'confirmCtrl',
        className: 'ne__modal'
      })
    }

    $rootScope.warning_confirm_modal = (opts) => {
      return ngDialog.open({
        template: '/app/views/modal/warning_confirm.html',
        data: opts,
        controller: 'confirmCtrl',
        className: 'ne__modal'
      })
    }

    $rootScope.activityProcessed = (apptUuid = null, withPopupCallback = null, withoutPopupCallback = null) => {
      if(apptUuid) {
        appt = Appointment.$find(apptUuid)
        appt.$then(() => {
          activityProcessedAction(appt, withPopupCallback, withoutPopupCallback)
        })
      } else if(withoutPopupCallback) {
        withoutPopupCallback()
      }
    }

    activityProcessedAction = (appt, withPopupCallback, withoutPopupCallback) => {
      action = undefined
      action_at = undefined
      if(appt){
        if(appt.confirmed){
          action = "confirmed"
          action_at = appt["confirmed_at"]
        } else if(appt.cancelled){
          action = "cancelled"
          action_at = appt["cancelled_at"]
        }
      }
      if(typeof action != 'undefined'){
        text = "This appointment was already " + action
        if (action_at) {
          text = text + " at " + moment(action_at).format('MM/DD/YY hh:mm a') + "."
        } else {
          text = text + "."
        }
        confirmDialog = ngDialog.open({
          template: '/app/views/shared/modal-popup-info.html',
          data: { title: "Already " + action,
                  text: [text]
          },
          className: 'ne__modal'
        })
        confirmDialog.closePromise.then(data => {
          if(action == 'confirmed'){
            $rootScope.$broadcast('apptConfirmed', appt)
          } else if(action == 'cancelled') {
            $rootScope.$broadcast('cancelEvents', [appt.id])
          }
        })
        if(withPopupCallback){
          withPopupCallback()
        }
      } else if(withoutPopupCallback) {
        withoutPopupCallback()
      }
    }

    $rootScope.titleCase = (str) => str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
})
